import { AuthApi, UrlApi } from "../../../services/apirest";

export const normalizarCuit = (cuit) => String(cuit || "").replace(/\D/g, "");

const parseJsonSafe = async (res) => {
  try {
    return await res.json();
  } catch {
    return null;
  }
};

export const getProveedorByCuit = async (cuit) => {
  const cuitNorm = normalizarCuit(cuit);
  if (cuitNorm.length !== 11) {
    throw new Error("Ingrese un CUIT válido (11 dígitos)");
  }

  const res = await fetch(`${UrlApi}/proveedores/bycuit/${cuitNorm}`);
  if (!res.ok) {
    throw new Error("No se pudieron obtener los datos del proveedor");
  }

  const rows = await res.json();
  if (!Array.isArray(rows) || rows.length === 0) {
    return null;
  }
  return rows[0];
};

export const listProveedoresAuth = async ({ activo } = {}) => {
  const params = new URLSearchParams();
  if (activo === 0 || activo === 1) {
    params.set("activo", String(activo));
  }
  const query = params.toString();
  const url = query
    ? `${UrlApi}/proveedores/users-cuit?${query}`
    : `${UrlApi}/proveedores/users-cuit`;

  const res = await fetch(url);

  if (!res.ok) {
    const data = await parseJsonSafe(res);
    throw new Error(
      data?.msg || data?.message || "No se pudo obtener el listado de proveedores"
    );
  }

  const data = await res.json();

  if (data?.ok === false) {
    throw new Error(data?.message || "No se pudo obtener el listado de proveedores");
  }

  const rows = Array.isArray(data?.data) ? data.data : [];

  return { rows, total: data?.total ?? rows.length };
};

export const updateProveedorEstado = async (cuit, activo, email) => {
  const cuitNorm = normalizarCuit(cuit);
  if (cuitNorm.length !== 11) {
    throw new Error("CUIT inválido");
  }

  const res = await fetch(`${UrlApi}/proveedores/users-cuit/estado`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ cuit: cuitNorm, activo, email }),
  });

  const data = await parseJsonSafe(res);

  if (!res.ok) {
    throw new Error(
      data?.msg || data?.message || "No se pudo actualizar el estado del proveedor"
    );
  }

  if (data?.ok === false) {
    throw new Error(
      data?.msg || data?.message || "No se pudo actualizar el estado del proveedor"
    );
  }

  return data;
};

export const signUpCuit = async (cuit, activo = 1, email) => {
  const cuitNorm = normalizarCuit(cuit);
  if (cuitNorm.length !== 11) {
    throw new Error("Ingrese un CUIT válido (11 dígitos)");
  }

  const res = await fetch(`${AuthApi.replace(/\/$/, "")}/sign-up-cuit`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ cuit: cuitNorm, activo, email }),
  });

  const data = await parseJsonSafe(res);

  if (!res.ok) {
    const msg =
      data?.msg ||
      data?.message ||
      (res.status === 409
        ? "Este CUIT ya posee un acceso al portal."
        : "No se pudo dar de alta el acceso al portal");
    const error = new Error(msg);
    if (res.status === 409) {
      error.accesoExistente = true;
    }
    throw error;
  }

  return {
    cuit: cuitNorm,
    activo,
    razon_social: data?.razon_social,
    msg: data?.msg || data?.message || "Acceso creado correctamente",
    ...data,
  };
};
